import React from 'react';

const Find: React.FC = () => {
    return (
        <div>
            <h1>Find</h1>
        </div>
    );
};

export default Find;